import axios from "axios";

type LogLevel = "debug" | "warn" | "error";

interface LogOptions {
  message: string;
  context?: Record<string, any>;
  level?: LogLevel;
  authToken: string;
}

export async function logToServer(
  { level = "debug", message, context = {}, authToken }: LogOptions,
  endpoint: string = process.env.REACT_APP_LOGGING_API_URL!
): Promise<void> {
  const logEntry = {
    level,
    message,
    context,
    timestamp: new Date().toISOString(),
  };

  if (process.env.NODE_ENV !== "production") {
    console[level === "error" ? "error" : level](logEntry);
  }

  try {
    await axios.post(endpoint, logEntry, {
      headers: {
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Content-Type": "application/json",
        authtoken: authToken,
      },
      timeout: 3000,
    });
  } catch (err) {
    console.warn("Logger failed to send log to server:", err);
  }
}
